import { render } from "./sendMessage.vue?vue&type=template&id=73f1c489&scoped=true"
import script from "./sendMessage.vue?vue&type=script&lang=js"
export * from "./sendMessage.vue?vue&type=script&lang=js"

import "./sendMessage.vue?vue&type=style&index=0&id=73f1c489&lang=scss"
import "./sendMessage.vue?vue&type=style&index=1&id=73f1c489&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f1c489"],['__file',"src/views/marketing/components/sendMessage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "73f1c489"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('73f1c489', __exports__)) {
    console.log('reload')
    api.reload('73f1c489', __exports__)
  }
  
  module.hot.accept("./sendMessage.vue?vue&type=template&id=73f1c489&scoped=true", () => {
    console.log('re-render')
    api.rerender('73f1c489', render)
  })

}


export default __exports__